import parseData from '@/utils/parseData'

export default {
  name: 'ClusterCard',
  props: {
    item: {
      type: Object,
      required: true
    },
    workspaceId: {
      type: Number,
      required: true
    },
    contentplanId: {
      type: Number,
      required: true
    },
    selectedMetric: {
      type: Object,
      default: () => ({ text: 'Search Volume', value: 'estimated_search_volume' })
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    keywords: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    selectedKeywords: {
      type: Array,
      default: () => []
    },
    showArticleCheckbox: {
      type: Boolean,
      default: true
    },
    showKeywordCheckbox: {
      type: Boolean,
      default: true
    },
    ctaButton: {
      type: String,
      default: 'add-to-favorites'
    },
    ctaButtonLoading: {
      type: Boolean,
      default: false
    },
    highlight: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    isWritten () {
      const writtenStatuses = ['reviewed', 'shared', 'illustrated', 'edited']
      return writtenStatuses.includes(this.item.status)
    },
    isPublished () {
      return this.item.status === 'published' || this.item.article_url !== null
    },
    isMapped () {
      return this.item.show_in_map
    }
  },
  methods: {
    parseData,
    handleCheckboxClick () {
      this.$emit('checkbox-click', this.item)
    },
    handleKeywordClick (keyword) {
      this.$emit('keyword-click', keyword)
    },
    isKeywordSelected (keywordId) {
      return this.selectedKeywords.includes(keywordId)
    },
    handleFavorite () {
      this.$emit('favorite-click', this.item)
    },
    handleWrite (item) {
      this.$emit('write-article', item)
    }
  }
}
